define([
	"csi/xml",
	"csi/def/ActionFactory",
	"./_StateAction"
], function(xml,ActionFactory,_StateAction) {

	return ActionFactory.declare("ForceApprove", _StateAction, {
		m_module: "Workflow",
		m_tag: "ForceApprove",
		_bRequiresWorkflow: true,
		_bProhibitsWorkflow: false,

		_getStateRoles: function(/*csi.def.Context*/ctx) {
			return ["Revision Approver"];
		},

		_hasStateAccess: function(/*csi.def.Context*/ctx, /*Node*/master, /*Node*/revision) {
			return true;
		}
	});
});